export const dmpSteps = [
  {
    num: '01',
    title: 'Onboarding',
    blurb: 'Connects to your ERP, MES, QMS and onboards suppliers and customers to submit or receive evidence directly.',
    body: 'Digital Material Passport connects to your existing ERP, MES, QMS, LIMS, and other plant systems where evidence already lives — no additional infrastructure, no new workflow for your team to learn. Suppliers and customers can also be connected directly to submit or receive evidence in real time.',
    tag: 'Integrates systems · supplier onboarding optional',
  },
  {
    num: '02',
    title: 'Digital Specification',
    blurb: 'Buyer requirements converted into machine-verifiable logic.',
    body: 'Buyer requirements, material specs, and regulatory standards are extracted from PDFs and drawings, then converted into machine-verifiable logic — expert-reviewed, then frozen.',
    tag: 'AI drafts · expert approves',
  },
  {
    num: '03',
    title: 'Digital Negotiation',
    blurb: 'Buyer, factory, and supplier align once on what evidence looks like.',
    body: 'Buyer, factory, and supplier align on the evidence and formats required — once — so nobody is guessing what "proof" means at shipment time.',
    tag: 'Mutually signed & agreed',
  },
  {
    num: '04',
    title: 'Continuous Conformance',
    blurb: 'Evidence checked against spec, every shipment — proof issued automatically.',
    body: 'Supplier certificates, production data, and inspection results are collected, normalized, and checked against the frozen specification — deterministically, every time. A signed Material Conformance Certificate is issued automatically, traceable to its source evidence and independently verifiable by anyone downstream.',
    tag: 'Deterministic · signed · verifiable',
  },
];
